import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { GallerySection } from '@/types/sections/GallerySection';
import { Markdown } from '@/components/markdown';
import { alpha, useTheme } from '@mui/material';
import { getCtaUrl } from '@/types/Cta';
// ----------------------------------------------------------------------

type Props = {
  section?: GallerySection;
};

function handleSubmit(arg0: () => Promise<void>) {
  throw new Error('Function not implemented.');
}

export function GallerySummary({ section, ...other }: Props) {
  const theme = useTheme();

  return (
    <Stack spacing={3} sx={{ pt: 3 }} {...other}>
      <Stack spacing={2} alignItems="flex-start">
        {/*  */}
        <Box sx={{ gap: 1, display: 'flex', alignItems: 'center' }}>
        </Box>

        {/*  */}
        <Box component="span">
          {section?.labels?.join(' | ')}
        </Box>

        {/*  */}
        <Typography variant="h2" color='primary'>{section?.title}</Typography>

        {/*  */}
        <Markdown
          children={section?.summary}
          sx={[
            () => ({
              '& p, li, ol, table': { typography: 'body2' },
              '& table': {
                mt: 2,
                maxWidth: 640,
                '& td': { px: 2 },
                '& td:first-of-type': { color: 'text.secondary' },
                'tbody tr:nth-of-type(odd)': { bgcolor: 'transparent' },
              },

            }),
          ]}
        />
      </Stack>

      <Divider sx={{ borderStyle: 'dashed' }} />

      { section?.cta1 && (
        <Box sx={{ gap: 2, display: 'flex' }}>
          <Button fullWidth size="large" type="submit" variant="contained" 
            href={getCtaUrl(section.cta1)}
            sx={{ 
              borderRadius: 0,
              bgcolor: alpha(theme.palette.primary.main, 0.08), // Button background color
              color: theme.palette.primary.main, // Text color
              border: `1px solid alpha(theme.palette.primary.main, 0.2)`, // Border color
              '&:hover': {
                bgcolor: alpha(theme.palette.primary.main, 0.08), // Background color on hover
                border: `1px solid ${theme.palette.primary.main}`, // Border color on hover
              }, 
            }}>
            {section?.cta1.title}
          </Button>
        </Box>
      )}
    </Stack>
  );
}
